import styled from '@emotion/styled';

export const Line = styled.div`
  height: 0.063rem;
  width: 100%;
  background-color: ${({ theme }) => theme.color.light1};
`;
